<p-card data-variant="compact">
  <p-table [value]="settlements()" dataKey="id" [rowHover]="true" [loading]="isLoading()">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'ExpenseSettlement_Col_Number' | translateWF: 'Number' }}</th>
        <th class="text-right">{{ 'ExpenseSettlement_Col_Net' | translateWF: 'Net' }}</th>
        <th>{{ 'Status' | translateWF: 'Status' }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      @let row = getRow(rowData);
      <tr>
        <td>
          <a class="cs-table-link font-mono" (click)="open(row)">{{ row.number }}</a>
          <small class="block text-surface-500">{{ row.settlementDate | date: 'dd/MM/yyyy' : 'UTC' }}</small>
        </td>
        <td class="text-right tabular-nums">{{ symbolOf(row.currency) }} {{ row.net | number: '1.2-2' }}</td>
        <td><p-tag [severity]="statusSeverity(row.status)" [value]="statusLabel(row.status)" /></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center">{{ 'ExpenseSettlement_Owner_None' | translateWF: 'No settlements yet.' }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
